import {
  Box,
  Flex,
  FormControl,
  FormErrorMessage,
  Grid,
  GridItem,
  RadioGroup,
  Stack,
  Text,
} from "@chakra-ui/react";
import { Field } from "formik";
import { RadioButtonField } from "../../../../../components/RadioButtonField";

export const SituacaoAdocaoAba = ({ children, props }) => {
  return (
    <>
      <Flex mb={4} justifyContent={"space-between"}>
        <Text
          fontWeight={700}
          fontSize="16px"
          lineHeight="21.6px"
          color={"#575553"}
        >
          Situação quanto à Adoção
        </Text>
        {children}
      </Flex>

      <Box>
        <Text
          color="#5F6377"
          fontWeight="500"
          fontSize="14px"
          lineHeight="19.6px"
          htmlFor={"Cumpre Requisitos para Adoção?"}
          mb={4}
          mt={7}
        >
          Cumpre Requisitos para Adoção?
        </Text>
        <Grid
          templateColumns="repeat(15, 1fr)"
          gap="15px"
          mt="15px"
          w="100%"
          alignItems={"center"}
        >
          <GridItem colSpan={{ base: 9, "2xl": 7 }}>
            <Field name="radioCumpreRequisito">
              {({ field, form }) => (
                <FormControl
                  isInvalid={
                    form.errors.radioCumpreRequisito &&
                    form.touched.radioCumpreRequisito
                  }
                  id="radioCumpreRequisito"
                  width="max-content"
                  zIndex={"1"}
                >
                  <RadioGroup
                    value={field.value}
                    onChange={(value) =>
                      props.setFieldValue("radioCumpreRequisito", value)
                    }
                  >
                    <Stack direction="row" gap={4}>
                      <RadioButtonField
                        id="radio-cumpreRequisito-s"
                        fieldName="radioCumpreRequisito"
                        value="S"
                        label="Sim"
                      />
                      <RadioButtonField
                        id="radio-cumpreRequisito-n"
                        fieldName="radioCumpreRequisito"
                        value="N"
                        label="Não"
                      />
                    </Stack>
                  </RadioGroup>
                  <FormErrorMessage mt="-1" mr="-16">
                    {form.errors.radioCumpreRequisito}
                  </FormErrorMessage>
                </FormControl>
              )}
            </Field>
          </GridItem>
        </Grid>
      </Box>
    </>
  );
};
